import { createContext, useContext } from 'react';

import { DEFAULT_LEGEND } from '../defaults.js';
import { TreemapChartLegendConfig } from '../types/treemap-chart.config.js';

export const ChartLegendContext =
  createContext<TreemapChartLegendConfig>(DEFAULT_LEGEND);

export const useChartLegend = () => useContext(ChartLegendContext);

ChartLegendContext['displayName'] = 'ChartLegendContext';
